import { render, staticRenderFns } from "./trashedPaymentGateways.vue?vue&type=template&id=32e8558e&scoped=true"
import script from "./trashedPaymentGateways.vue?vue&type=script&lang=js"
export * from "./trashedPaymentGateways.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32e8558e",
  null
  
)

export default component.exports